import React from 'react';
import { Heart } from 'lucide-react';
import { motion } from 'framer-motion';

const RoleSaveButton = ({ isSaved, isUpdating, onClick, isLoading = false }) => {
  return (
    <motion.button
      whileTap={{ scale: 0.9 }}
      onClick={onClick}
      disabled={isUpdating || isLoading}
      className={`absolute top-4 right-4 z-10 p-2 flex items-center justify-center bg-transparent border-none group ${
        (isUpdating || isLoading) ? 'opacity-50 cursor-not-allowed' : ''
      }`}
      aria-label={isSaved ? "Remove from saved" : "Save role"}
    >
      {isUpdating || isLoading ? (
        <span className="w-4 h-4 border-2 border-current border-t-transparent rounded-full animate-spin"></span>
      ) : (
        <Heart
          className={`w-7 h-7 transition-all duration-100 ${
            isSaved 
              ? 'text-red-500 fill-red-500' 
              : 'text-gray-700 group-hover:text-red-500 stroke-2 drop-shadow-[0_1px_1px_rgba(255,255,255,0.7)]'
          }`}
          strokeWidth={2.5}
        />
      )}
    </motion.button>
  );
};

export default RoleSaveButton;